import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { RootStore } from "store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getCurrentUserRequest } from "store/slices/authSlice";

import { TOKEN_KEY } from "utils/constants";
import { CookieHelper } from "utils/helpers";
import { PAGES } from "utils/links";

interface PrivateRouteProps {
  children: React.ReactElement;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isLoading, user } = useAppSelector((state: RootStore) => state.auth);
  const location = useLocation();
  const token = CookieHelper.getCookie(TOKEN_KEY);

  useEffect(() => {
    if (token && !user) {
      dispatch(getCurrentUserRequest());
    }
  }, [token, user, dispatch]);

  if (isLoading || (token && !user)) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to={PAGES.LOGIN} state={{ from: location }} replace />;
  }

  return children;
};
